export const regionOptions = [
  { key: 1, value: 1, text: "Benelux" },
  { key: 2, value: 2, text: "Scandinavia" },
  { key: 3, value: 3, text: "UK & Ireland" },
  { key: 4, value: 4, text: "Balkans" },
  { key: 5, value: 5, text: "Iberia" },
  { key: 6, value: 6, text: "DACH" },
  { key: 7, value: 7, text: "Nordics" },
  { key: 8, value: 8, text: "Baltics" },
  { key: 9, value: 9, text: "Central Europe" },
  { key: 10, value: 10, text: "Eastern Europe" },
  { key: 11, value: 11, text: "Southern Europe" },
].sort((a, b) => a.text.localeCompare(b.text));

export const countryOptions = [
  { key: 1, value: 1, text: "Netherlands" },
  { key: 2, value: 2, text: "Poland" },
  { key: 3, value: 3, text: "France" },
  { key: 4, value: 4, text: "Spain" },
  { key: 5, value: 5, text: "Portugal" },
  { key: 6, value: 6, text: "Italy" },
  { key: 7, value: 7, text: "Germany" },
  { key: 8, value: 8, text: "Czech Republic" },
  { key: 9, value: 9, text: "Slovakia" },
  { key: 10, value: 10, text: "Denmark" },
  { key: 11, value: 11, text: "Belgium" },
  { key: 12, value: 12, text: "Hungary" },
  { key: 13, value: 13, text: "Sweden" },
  { key: 14, value: 14, text: "Slovenia" },
  { key: 15, value: 15, text: "Austria" },
  { key: 16, value: 16, text: "Luxembourg" },
  { key: 17, value: 17, text: "Switzerland" },
  { key: 18, value: 18, text: "Romania" },
  { key: 19, value: 19, text: "Lithuania" },
  { key: 20, value: 20, text: "Norway" },
  { key: 21, value: 21, text: "Finland" },
  { key: 22, value: 22, text: "Greece" },
  { key: 23, value: 23, text: "Croatia" },
  { key: 24, value: 24, text: "Serbia" },
  { key: 25, value: 25, text: "Estonia" },
  { key: 26, value: 26, text: "Latvia" },
].sort((a, b) => a.text.localeCompare(b.text));

export const laneCountryOptions = [
  { key: "NL", value: "NL", text: "NL" },
  { key: "PL", value: "PL", text: "PL" },
  { key: "FR", value: "FR", text: "FR" },
  { key: "ES", value: "ES", text: "ES" },
  { key: "PT", value: "PT", text: "PT" },
  { key: "IT", value: "IT", text: "IT" },
  { key: "DE", value: "DE", text: "DE" },
  { key: "CZ", value: "CZ", text: "CZ" },
  { key: "SK", value: "SK", text: "SK" },
  { key: "DK", value: "DK", text: "DK" },
  { key: "BE", value: "BE", text: "BE" },
  { key: "HU", value: "HU", text: "HU" },
  { key: "SE", value: "SE", text: "SE" },
  { key: "SI", value: "SI", text: "SI" },
  { key: "AT", value: "AT", text: "AT" },
  { key: "LU", value: "LU", text: "LU" },
  { key: "CH", value: "CH", text: "CH" },
  { key: "RO", value: "RO", text: "RO" },
  { key: "LT", value: "LT", text: "LT" },
  { key: "NO", value: "NO", text: "NO" },
  { key: "FI", value: "FI", text: "FI" },
  { key: "GR", value: "GR", text: "GR" },
  { key: "HR", value: "HR", text: "HR" },
  { key: "RS", value: "RS", text: "RS" },
].sort((a, b) => a.text.localeCompare(b.text));

export const directionOptions = [
  { key: "north", value: "North", text: "North" },
  { key: "south", value: "South", text: "South" },
  { key: "east", value: "East", text: "East" },
  { key: "west", value: "West", text: "West" },
].sort((a, b) => a.text.localeCompare(b.text));
